import { createFileRoute } from "@tanstack/react-router";
import { AmenitiesPage } from "@/components/pages/AmenitiesPage";

export const Route = createFileRoute("/amenities/")({
  component: AmenitiesPage,
});
